// All 66 books of the Bible with chapter counts and API slugs for bible-api.com
// URL format: https://bible-api.com/${slug}+${chapter}?translation=${translationId}

import { DEFAULT_BIBLE_TRANSLATION } from '@/lib/queries/_constants'

export const BIBLE_BOOKS = [
  // ── Old Testament ─────────────────────────────────────────
  { name: 'Genesis', slug: 'genesis', chapters: 50, testament: 'OT' },
  { name: 'Exodus', slug: 'exodus', chapters: 40, testament: 'OT' },
  { name: 'Leviticus', slug: 'leviticus', chapters: 27, testament: 'OT' },
  { name: 'Numbers', slug: 'numbers', chapters: 36, testament: 'OT' },
  { name: 'Deuteronomy', slug: 'deuteronomy', chapters: 34, testament: 'OT' },
  { name: 'Joshua', slug: 'joshua', chapters: 24, testament: 'OT' },
  { name: 'Judges', slug: 'judges', chapters: 21, testament: 'OT' },
  { name: 'Ruth', slug: 'ruth', chapters: 4, testament: 'OT' },
  { name: '1 Samuel', slug: '1 samuel', chapters: 31, testament: 'OT' },
  { name: '2 Samuel', slug: '2 samuel', chapters: 24, testament: 'OT' },
  { name: '1 Kings', slug: '1 kings', chapters: 22, testament: 'OT' },
  { name: '2 Kings', slug: '2 kings', chapters: 25, testament: 'OT' },
  { name: '1 Chronicles', slug: '1 chronicles', chapters: 29, testament: 'OT' },
  { name: '2 Chronicles', slug: '2 chronicles', chapters: 36, testament: 'OT' },
  { name: 'Ezra', slug: 'ezra', chapters: 10, testament: 'OT' },
  { name: 'Nehemiah', slug: 'nehemiah', chapters: 13, testament: 'OT' },
  { name: 'Esther', slug: 'esther', chapters: 10, testament: 'OT' },
  { name: 'Job', slug: 'job', chapters: 42, testament: 'OT' },
  { name: 'Psalms', slug: 'psalms', chapters: 150, testament: 'OT' },
  { name: 'Proverbs', slug: 'proverbs', chapters: 31, testament: 'OT' },
  { name: 'Ecclesiastes', slug: 'ecclesiastes', chapters: 12, testament: 'OT' },
  { name: 'Song of Solomon', slug: 'song of solomon', chapters: 8, testament: 'OT' },
  { name: 'Isaiah', slug: 'isaiah', chapters: 66, testament: 'OT' },
  { name: 'Jeremiah', slug: 'jeremiah', chapters: 52, testament: 'OT' },
  { name: 'Lamentations', slug: 'lamentations', chapters: 5, testament: 'OT' },
  { name: 'Ezekiel', slug: 'ezekiel', chapters: 48, testament: 'OT' },
  { name: 'Daniel', slug: 'daniel', chapters: 12, testament: 'OT' },
  { name: 'Hosea', slug: 'hosea', chapters: 14, testament: 'OT' },
  { name: 'Joel', slug: 'joel', chapters: 3, testament: 'OT' },
  { name: 'Amos', slug: 'amos', chapters: 9, testament: 'OT' },
  { name: 'Obadiah', slug: 'obadiah', chapters: 1, testament: 'OT', singleChapterVerses: 21 },
  { name: 'Jonah', slug: 'jonah', chapters: 4, testament: 'OT' },
  { name: 'Micah', slug: 'micah', chapters: 7, testament: 'OT' },
  { name: 'Nahum', slug: 'nahum', chapters: 3, testament: 'OT' },
  { name: 'Habakkuk', slug: 'habakkuk', chapters: 3, testament: 'OT' },
  { name: 'Zephaniah', slug: 'zephaniah', chapters: 3, testament: 'OT' },
  { name: 'Haggai', slug: 'haggai', chapters: 2, testament: 'OT' },
  { name: 'Zechariah', slug: 'zechariah', chapters: 14, testament: 'OT' },
  { name: 'Malachi', slug: 'malachi', chapters: 4, testament: 'OT' },

  // ── New Testament ─────────────────────────────────────────
  { name: 'Matthew', slug: 'matthew', chapters: 28, testament: 'NT' },
  { name: 'Mark', slug: 'mark', chapters: 16, testament: 'NT' },
  { name: 'Luke', slug: 'luke', chapters: 24, testament: 'NT' },
  { name: 'John', slug: 'john', chapters: 21, testament: 'NT' },
  { name: 'Acts', slug: 'acts', chapters: 28, testament: 'NT' },
  { name: 'Romans', slug: 'romans', chapters: 16, testament: 'NT' },
  { name: '1 Corinthians', slug: '1 corinthians', chapters: 16, testament: 'NT' },
  { name: '2 Corinthians', slug: '2 corinthians', chapters: 13, testament: 'NT' },
  { name: 'Galatians', slug: 'galatians', chapters: 6, testament: 'NT' },
  { name: 'Ephesians', slug: 'ephesians', chapters: 6, testament: 'NT' },
  { name: 'Philippians', slug: 'philippians', chapters: 4, testament: 'NT' },
  { name: 'Colossians', slug: 'colossians', chapters: 4, testament: 'NT' },
  { name: '1 Thessalonians', slug: '1 thessalonians', chapters: 5, testament: 'NT' },
  { name: '2 Thessalonians', slug: '2 thessalonians', chapters: 3, testament: 'NT' },
  { name: '1 Timothy', slug: '1 timothy', chapters: 6, testament: 'NT' },
  { name: '2 Timothy', slug: '2 timothy', chapters: 4, testament: 'NT' },
  { name: 'Titus', slug: 'titus', chapters: 3, testament: 'NT' },
  { name: 'Philemon', slug: 'philemon', chapters: 1, testament: 'NT', singleChapterVerses: 25 },
  { name: 'Hebrews', slug: 'hebrews', chapters: 13, testament: 'NT' },
  { name: 'James', slug: 'james', chapters: 5, testament: 'NT' },
  { name: '1 Peter', slug: '1 peter', chapters: 5, testament: 'NT' },
  { name: '2 Peter', slug: '2 peter', chapters: 3, testament: 'NT' },
  { name: '1 John', slug: '1 john', chapters: 5, testament: 'NT' },
  { name: '2 John', slug: '2 john', chapters: 1, testament: 'NT', singleChapterVerses: 13 },
  { name: '3 John', slug: '3 john', chapters: 1, testament: 'NT', singleChapterVerses: 14 },
  { name: 'Jude', slug: 'jude', chapters: 1, testament: 'NT', singleChapterVerses: 25 },
  { name: 'Revelation', slug: 'revelation', chapters: 22, testament: 'NT' },
]

// Translations the reader can show, ordered by US Christian market share
// (most popular first). NIV/ESV are absent — see business/context.md for
// the licensing situation. `licensed: true` = routed through the
// fetch-bible-chapter edge function (cached in Supabase, served from
// API.Bible on miss). Everything else goes to bible-api.com directly.
export const BIBLE_TRANSLATIONS = [
  // Popular picks
  { id: 'kjv', label: 'KJV', full: 'King James Version' }, // ~15–20% share
  { id: 'nlt', label: 'NLT', full: 'New Living Translation', licensed: true }, // ~8–10% share
  { id: 'nkjv', label: 'NKJV', full: 'New King James Version', licensed: true }, // ~5–8% share
  { id: 'nasb20', label: 'NASB20', full: 'New American Standard Bible 2020', licensed: true }, // ~3–5% share — NASB95 is a separate edition
  // Niche / scholarly / archaic — kept for completeness, less-commonly used
  { id: 'web', label: 'WEB', full: 'World English Bible' },
  { id: 'asv', label: 'ASV', full: 'American Standard Version' },
  { id: 'ylt', label: 'YLT', full: "Young's Literal Translation", ntOnly: true },
  { id: 'bbe', label: 'BBE', full: 'Bible in Basic English' },
]

export const FONT_SIZES = [
  { id: 'small', label: 'Small', size: '14px', leading: '1.75' },
  { id: 'medium', label: 'Medium', size: '17px', leading: '1.9' },
  { id: 'large', label: 'Large', size: '20px', leading: '2.0' },
  { id: 'xl', label: 'XL', size: '24px', leading: '2.1' },
]

export const FONT_FAMILIES = [
  { id: 'serif', label: 'Serif', family: "'Noto Serif', Georgia, serif" },
  { id: 'sans', label: 'Sans', family: "'Inter', system-ui, sans-serif" },
  { id: 'mono', label: 'Mono', family: "'JetBrains Mono', 'Courier New', monospace" },
]

export const HIGHLIGHT_COLORS = [
  { id: 'gold', color: '#e9c349', label: 'Gold' },
  { id: 'blue', color: '#4a8fd4', label: 'Blue' },
  { id: 'green', color: '#5a9e6f', label: 'Green' },
  { id: 'pink', color: '#d4748a', label: 'Pink' },
  { id: 'purple', color: '#9b59d6', label: 'Purple' },
]

export function getBook(name) {
  return BIBLE_BOOKS.find(b => b.name === name)
}

export function getTranslation(id) {
  return BIBLE_TRANSLATIONS.find(t => t.id === id)
}

/** True when the translation is served via the fetch-bible-chapter edge
 *  function (API.Bible + Supabase cache), false when it's a direct
 *  bible-api.com fetch. */
export function isLicensedTranslation(id) {
  return !!getTranslation(id)?.licensed
}

/** Normalize a profile-stored translation value to a canonical id (e.g.
 *  'kjv', 'nasb20'). The picker UI saves labels (e.g. 'NASB', 'WEB') to
 *  `profiles.preferred_translation`, but the Reader, popover, and edge
 *  function all key off the lowercase ids. Without this resolve step,
 *  'NASB' falls through every match in `BIBLE_TRANSLATIONS` (label is
 *  'NASB20'), gets treated as public-domain, and bible-api.com 404s
 *  because NASB is licensed-only — leaving the user with the
 *  Couldn't-load-this-verse-here error. Order: by label, then by id,
 *  then legacy unsuffixed 'NASB' → 'nasb20', else default. */
export function resolveTranslationId(stored) {
  const value = stored || DEFAULT_BIBLE_TRANSLATION.toUpperCase()
  const byLabel = BIBLE_TRANSLATIONS.find(tr => tr.label === value)
  if (byLabel) return byLabel.id
  const byId = BIBLE_TRANSLATIONS.find(tr => tr.id === String(value).toLowerCase())
  if (byId) return byId.id
  if (value === 'NASB') return 'nasb20'
  return DEFAULT_BIBLE_TRANSLATION
}

export function buildApiUrl(slug, chapter, translation, singleChapterVerses) {
  const encodedSlug = slug.replace(/ /g, '+')
  // Single-chapter books: API interprets "obadiah+1" as verse 1, not chapter 1
  // Must use explicit verse range: "obadiah+1:1-21"
  if (singleChapterVerses) {
    return `https://bible-api.com/${encodedSlug}+1:1-${singleChapterVerses}?translation=${translation}`
  }
  return `https://bible-api.com/${encodedSlug}+${chapter}?translation=${translation}`
}
